import {useUpmPlant} from '@hconnect/upm'
import {FilterMultiSelect, FilterMultiSelectProps} from '@widgets/common-filters'

import {FILTER_VALUE_SEPARATOR} from '../../consts'
import {useOilAnalysisCriticalities} from '../../hooks'

export const CriticalityFilter = <TName extends string>({
  plantId,
  ...props
}: Omit<FilterMultiSelectProps<string, TName>, 'options'> & {plantId?: string}) => {
  const upmPlant = useUpmPlant({plantId: plantId ?? '', shouldRaiseError: false})
  const plantUpmId = upmPlant?.upmId ?? ''

  const {data: criticalities = []} = useOilAnalysisCriticalities(plantUpmId)
  const options = criticalities.map((status) => ({
    value: status,
    label: status
  }))

  return (
    <FilterMultiSelect
      {...props}
      options={options}
      getOptionLabel={({label}) => label}
      renderValue={(value) => value.join(FILTER_VALUE_SEPARATOR)}
    />
  )
}
